import { Link } from "react-router-dom";

const sections = {
  PrivacyPolicy: { title: "Privacy Policy", color: "var(--neon)", icon: "🔒", last: "March 2026", content: ["We collect only the data needed to operate WalkBattle: your account info, walk/step data, and device identifiers for push notifications.","Your real-time location is processed on-device. We store only aggregated path data — not your live GPS coordinates.","We never sell your personal data to advertisers or third parties. Your fitness data belongs to you.","You can request full data deletion at any time via the Delete Data page. We process all requests within 30 days.","Data is encrypted at rest (AES-256) and in transit (TLS 1.3). We use industry-standard security practices."] },
  Terms: { title: "Terms of Service", color: "var(--neon3)", icon: "📋", last: "March 2026", content: ["WalkBattle is a free platform. By creating an account, you agree to these terms and our Community Guidelines.","You must be 13+ to use WalkBattle. Users under 18 require parental consent.","You are responsible for all activity under your account. Do not share credentials.","Cheating, spoofing GPS, or exploiting bugs is strictly prohibited and will result in permanent ban.","We reserve the right to modify or suspend the service with reasonable notice. Your data will be exportable before any shutdown."] },
  RefundPolicy: { title: "Refund Policy", color: "var(--neon2)", icon: "💸", last: "March 2026", content: ["WalkBattle is entirely free to use. We do not charge for account creation, core features, or leaderboard access.","Currently, there are no in-app purchases available. All coins and rewards are earned through activity.","If future paid features are introduced, a clear refund policy will be communicated before launch.","For any billing disputes related to third-party payment processors, contact us at support@walkbattle.app."] },
  CookiePolicy: { title: "Cookie Policy", color: "var(--gold)", icon: "🍪", last: "March 2026", content: ["We use minimal cookies strictly necessary for authentication and session management.","Analytics cookies (anonymous) help us understand app usage and improve features. These can be disabled.","We do not use advertising or tracking cookies. We do not participate in cross-site tracking.","You can clear cookies at any time from your browser or app settings without losing your account."] },
  DataDeletion: { title: "Data Deletion", color: "var(--danger)", icon: "🗑️", last: "March 2026", content: ["You have the right to delete your WalkBattle account and all associated data at any time.","To delete: open the app → Profile → Settings → Delete Account. Or email support@walkbattle.app.","Deletion is processed within 30 days. Walk data, territory history, and battle records are permanently removed.","Anonymized, aggregated data (e.g. total city-wide steps) may be retained in statistical form without any identifying information.","After deletion, you can create a new account at any time, but previous data cannot be restored."] },
}["RefundPolicy"];

export default function RefundPolicy() {
  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh", paddingTop: 80, overflowX: "hidden" }}>
      <style>{`
        .wb-policy-section {
          padding: 80px 48px;
          max-width: 860px;
          margin: 0 auto;
        }

        /* Tablet (768px - 1024px) */
        @media (max-width: 1024px) {
          .wb-policy-section {
            padding: 60px 28px;
          }
        }

        /* Mobile (< 640px) */
        @media (max-width: 640px) {
          .wb-policy-section {
            padding: 48px 16px;
          }
        }
      `}</style>

      <section className="wb-policy-section">
        <div style={{ marginBottom: 40 }}>
          <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: sections.color, letterSpacing: 3, textTransform: "uppercase", marginBottom: 14 }}>
            {sections.icon} Legal
          </div>
          <h1 style={{ fontFamily: "'Orbitron', monospace", fontSize: "clamp(26px, 5vw, 44px)", fontWeight: 900, color: "var(--text)", marginBottom: 10, lineHeight: 1.1 }}>
            {sections.title}
          </h1>
          <p style={{ color: "var(--muted)", fontSize: 13, fontFamily: "monospace" }}>Last updated: {sections.last}</p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {sections.content.map((text, i) => (
            <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 10, padding: "18px 20px" }}>
              <span style={{ color: sections.color, fontFamily: "monospace", fontSize: 13, flexShrink: 0, marginTop: 2, fontWeight: 700 }}>
                0{i + 1}.
              </span>
              <p style={{ color: "var(--muted)", fontSize: 15, lineHeight: 1.8 }}>{text}</p>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 40, padding: "24px 20px", background: "rgba(0,245,196,0.04)", border: "1px solid rgba(0,245,196,0.12)", borderRadius: 10, textAlign: "center" }}>
          <p style={{ color: "var(--muted)", fontSize: 14, marginBottom: 14 }}>Questions about refunds?</p>
          <Link to="/contact" style={{ color: "var(--neon)", fontFamily: "'Orbitron', monospace", fontSize: 11, fontWeight: 800, letterSpacing: 2, textDecoration: "none", textTransform: "uppercase" }}>
            Contact Us →
          </Link>
        </div>
      </section>
    </div>
  );
}

